// extracted by mini-css-extract-plugin
export default {"projectdisplay_outer":"Projectdisplay_projectdisplay_outer__ce+Mb"};